(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-product-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sh-reviews-link]');
    if (!link) return;

    var id = (link.getAttribute('href') || '').replace('#', '');
    var target =
      (id && document.getElementById(id)) ||
      document.getElementById('sh-reviews') ||
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget, .jdgm-rev-widg');

    if (!target) return;

    event.preventDefault();
    var header = document.querySelector('sticky-header, #shopify-section-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-quantity-box"] && !Shopify.designMode) return;
  try {
    function shUpdateQuantityLabel(input) {
    if (!input || input.name !== 'quantity') return;
    var box = input.closest('.sh-quantity-box');
    if (!box) return;

    var count = box.querySelector('[data-sh-quantity-count]');
    if (count) count.textContent = input.value;

    var unit = box.querySelector('[data-sh-quantity-unit]');
    if (!unit) return;
    var singular = unit.getAttribute('data-singular');
    var plural = unit.getAttribute('data-plural');
    if (!singular) return;
    var qty = Number(input.value || 0);
    unit.textContent = ' ' + (qty === 1 ? singular : plural || singular);
  }

  document.addEventListener('change', function (event) {
    shUpdateQuantityLabel(event.target);
  });
  document.addEventListener('input', function (event) {
    shUpdateQuantityLabel(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
